import humps from "humps"

export const API_ROOT_URL = process.env.NEXT_PUBLIC_GLUFORMER_BACKEND_URL
export const SELF_RECORDING_APP_URL = process.env.NEXT_PUBLIC_SELF_RECORDING_APP_URL

export function buildQueryParamsFromObject(paramsObj, decamelize = true) {
  const queryString = Object.entries(paramsObj).reduce(
    (partialQueryString, [key, value]) => {
      key = decamelize ? humps.decamelize(key) : key
      if (value) {
        return `${partialQueryString}&${encodeURIComponent(
          key
        )}=${encodeURIComponent(value)}`
      }
      return partialQueryString
    },
    ""
  )
  return queryString
}
